import React from "react";
import slugifyAnchor from "../helpers/slugifyAnchor";
import TableOfContents from "./TableOfContents";

const TableOfContentsBlock = ({ block }) => {
    const blockId = slugifyAnchor(block?.blockId) || "table-of-contents";
    const items = (block?.items || [])
        .filter((item) => item?.content && item?.anchorId)
        .map((item) => ({
            id: slugifyAnchor(item.anchorId),
            label: item.content,
        }))
        .filter((item) => item.id);

    if (!items.length) {
        return null;
    }

    return (
        <div className="table-of-contents-block">
            <TableOfContents
                items={items}
                eyebrow={block.eyebrow || "Agenda / Table of contents"}
                title={block.title || "Table of contents"}
                titleId={`${blockId}-title`}
            />
        </div>
    );
};

export default TableOfContentsBlock;
